export enum CROSSTOWN_ROUTE_PARAMS {
  OPEN_SELECT_LOCKER_SIZE = 'OPEN_SELECT_LOCKER_SIZE',
  OPEN_SELECT_PHONE = 'OPEN_SELECT_PHONE',
  OPEN_SELECT_ADDRESS = 'OPEN_SELECT_ADDRESS',
}

export const CLICK_AND_COLLECT_HIDE_INFO_ID = 'click-and-collect-hide-message';
export const CLICK_AND_COLLECT_VALUE = 'true'; // local storage only accepts strings

export enum EClickCollectType {
  NONE = 'none',
  CLIENT = 'client',
  SHOP = 'shop',
}

import {CROSS_TOWN_ROUTES} from "@/constants/routes";
import {translateString} from "@/services/languageUtils";

export const CROSS_TOWN_HIDE_INFO_ID = 'cross-town-hide-message';
export const CROSS_TOWN_LS_VALUE = 'true'; // local storage only accepts strings


export enum ORDER_PROCESS_DROPUP_PAGE {
  EMPTY_PAGE = "",
  RECEIVER_PHONE = "RECEIVER_PHONE",
  CELL_CHOOSER = "CELL_CHOOSER",
  SELECT_HUB = "SELECT_HUB",
}


export enum CELL_SIZES {
  UNDEFINED_SIZE = 0,
  SIZE_ID_SMALL = 100,
  SIZE_ID_MEDIUM = 200,
  SIZE_ID_LARGE = 300,
}

export const cellSizesTranslatedStrings = (id: number): string => {
  const translationString = id === CELL_SIZES.SIZE_ID_SMALL  ? 'cells.cellSizeSmall'  :
          id === CELL_SIZES.SIZE_ID_MEDIUM ? 'cells.cellSizeMedium' :
          id === CELL_SIZES.SIZE_ID_LARGE  ? 'cells.cellSizeLarge'  :
                                             'cells.unknown';

  return translateString(translationString);
};

export enum CROSS_TOWN_STEPS {
  START = '1',
  NOTES = '2',
  SUMMARY = '3',
  PAYMENT = '4',
}

export interface IStringMap { [key: string]: string; }

export const NEXT_ROUTE_MAP: IStringMap = {
  [CROSS_TOWN_STEPS.START]: CROSS_TOWN_ROUTES.START,
  [CROSS_TOWN_STEPS.NOTES]: CROSS_TOWN_ROUTES.FORM,
  [CROSS_TOWN_STEPS.SUMMARY]: CROSS_TOWN_ROUTES.SUMMARY,
  [CROSS_TOWN_STEPS.PAYMENT]: CROSS_TOWN_ROUTES.PAYMENT,
};


export const STEP_MAP: IStringMap = {
  [CROSS_TOWN_ROUTES.START]: CROSS_TOWN_STEPS.START,
  [CROSS_TOWN_ROUTES.FORM]: CROSS_TOWN_STEPS.NOTES,
  [CROSS_TOWN_ROUTES.SUMMARY]: CROSS_TOWN_STEPS.SUMMARY,
  [CROSS_TOWN_ROUTES.PAYMENT]: CROSS_TOWN_STEPS.PAYMENT,
};

export const LOADING_STATUS: IStringMap = {
  BEFORE_LOADING: "BEFORE_LOADING",
  // START: "START",
  LOADING: "LOADING",
  FINISH: "FINISH",
};

export enum DELIVERY_STATUS {
  AWAITING_DROPOFF = "AWAITING_DROPOFF",
  TO_BE_DELIVERED = "TO_BE_DELIVERED",
  IN_PROGRESS = "IN_PROGRESS",
  IS_IN_LOCKER = "IS_IN_LOCKER",
  ERROR = "ERROR",
}


export enum ACTIVE_SHIPMENT_TYPE {
  TYPE_CROSSTOWN_DELIVERY = 100,
  TYPE_EXTERNAL_INCOMING = 200,
  TYPE_CLICK_COLLECT_INCOMING = 300,
  TYPE_AMAZON_RETURNS_DELIVERY = 400,
  TYPE_PUBLIC_DELIVERY = 500,
}

export enum ACTIVE_SHIPMENT_STATUS {
  STATUS_DISCARDED = 0, // will not come from the api
  STATUS_COMPLETED = 90, // will not come from the api

  // this ones will be shown in the sender
  STATUS_NEW = 10,
  STATUS_AWAITING_DROPOFF = 20,

  // Those would be shown in the recipient
  STATUS_AWAITING_COLLECT = 30, // by the delivery service
  STATUS_PROCESSING = 50,
  STATUS_IN_DELIVER = 70,
  STATUS_AWAITING_PICKUP = 80,

}

export enum PAYMENT_STATUS {
  PAYMENT_STATUS_UNPAID = 10,
  PAYMENT_STATUS_DECLINED = 20,
  PAYMENT_STATUS_PAID = 30,
}

export const MAX_CHAR: number = 191;
export const WARNING_LENGTH: number = 20;


